/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Download_BtnInputs */



/**
* | output |
* | --- |
* | "Download" |
*
* @param {Nda_Download_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_download_btn = /** @type {((inputs?: Nda_Download_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Download_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica")
	return /** @type {LocalizedString} */ ("Download")
});